export const setRbSourceFromUTM = () => {
	if (typeof window === 'undefined') return;

	const params = new URLSearchParams(window.location.search);
	const rb = params.get('rb');
	const source = params.get('utm_source');
	const medium = params.get('utm_medium');

	if (rb) {
		sessionStorage.setItem('rb_source', rb);
	} else if (source === 'facebook') {
		let rbSource = '';

		if (medium === 'ad') {
			rbSource = 'FB_Ad-VC';
		} else if (medium === 'organic') {
			rbSource = 'FB_Organic-VC';
		}

		if (rbSource) {
			sessionStorage.setItem('rb_source', rbSource);
		}
	}
};

export const getRbTrackedLink = (baseLink) => {
	if (typeof window === 'undefined') return baseLink;

	const rbSource = sessionStorage.getItem('rb_source');
	if (!rbSource) return baseLink;

	try {
		const url = new URL(baseLink);
		url.searchParams.set('rb', rbSource);
		return url.toString();
	} catch (e) {
		console.error('Invalid URL in getRbTrackedLink:', baseLink);
		return baseLink;
	}
};

export const getUpdatedRbInternalLink = (href) => {
	if (typeof window === 'undefined') return href;

	const rbSource = sessionStorage.getItem('rb_source');
	if (!rbSource) return href;

	try {
		const url = new URL(href, window.location.origin);
		url.searchParams.set('rb', rbSource);
		return url.toString().replace(window.location.origin, '');
	} catch (e) {
		console.error('Invalid URL in getUpdatedRbLink:', href);
		return href;
	}
};
